/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetTransactionByIdRequest = {
  /**
   * The unique identifier of the transaction.
   */
  transactionId: string;
};

/** @internal */
export const GetTransactionByIdRequest$inboundSchema: z.ZodType<
  GetTransactionByIdRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  transaction_id: z.string(),
}).transform((v) => {
  return remap$(v, {
    "transaction_id": "transactionId",
  });
});
/** @internal */
export type GetTransactionByIdRequest$Outbound = {
  transaction_id: string;
};

/** @internal */
export const GetTransactionByIdRequest$outboundSchema: z.ZodType<
  GetTransactionByIdRequest$Outbound,
  z.ZodTypeDef,
  GetTransactionByIdRequest
> = z.object({
  transactionId: z.string(),
}).transform((v) => {
  return remap$(v, {
    transactionId: "transaction_id",
  });
});

export function getTransactionByIdRequestToJSON(
  getTransactionByIdRequest: GetTransactionByIdRequest,
): string {
  return JSON.stringify(
    GetTransactionByIdRequest$outboundSchema.parse(getTransactionByIdRequest),
  );
}
export function getTransactionByIdRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetTransactionByIdRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetTransactionByIdRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetTransactionByIdRequest' from JSON`,
  );
}
